import Define from '../components/define';

export default Define;